import { render, staticRenderFns } from "./DigitalClinicsBookings.vue?vue&type=template&id=7161c18c&scoped=true"
import script from "./DigitalClinicsBookings.vue?vue&type=script&lang=js"
export * from "./DigitalClinicsBookings.vue?vue&type=script&lang=js"
import style0 from "./DigitalClinicsBookings.vue?vue&type=style&index=0&id=7161c18c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7161c18c",
  null
  
)

export default component.exports